import axios from "axios";

import { API_URL } from "@/config/constants";

import type {
    OutputTemplateDetail,
    OutputTemplateListItem,
    OutputTemplatePage,
    OutputTemplateUploadConfirm,
    OutputTemplateVersion,
} from "./output-templates.types";

const BASE = `${API_URL}/output-templates`;
export const OUTPUT_TEMPLATE_DETAIL_TIMEOUT_MS = 30_000;

export const listOutputTemplates = async ({
    search,
    page,
    size,
}: {
    search?: string;
    page: number;
    size: number;
}) => {
    const result = await axios.get<OutputTemplatePage>(BASE, {
        params: { search: search || undefined, page, size },
    });
    return result.data;
};

export const getOutputTemplateDetail = async (id: number) => {
    const result = await axios.get<OutputTemplateDetail>(`${BASE}/${id}`, {
        timeout: OUTPUT_TEMPLATE_DETAIL_TIMEOUT_MS,
    });
    return result.data;
};

export const uploadOutputTemplate = async (
    payload: OutputTemplateUploadConfirm
) => {
    const result = await axios.post<OutputTemplateListItem>(BASE, payload);
    return result.data;
};

export const replaceOutputTemplate = async (
    id: number,
    payload: OutputTemplateUploadConfirm
) => {
    const result = await axios.post<OutputTemplateListItem>(
        `${BASE}/${id}/replace`,
        payload
    );
    return result.data;
};

export const renameOutputTemplate = async (id: number, name: string) => {
    const result = await axios.patch<OutputTemplateListItem>(`${BASE}/${id}`, {
        name,
    });
    return result.data;
};

export const retryOutputTemplateCompile = async (id: number) => {
    const result = await axios.post<OutputTemplateVersion>(
        `${BASE}/${id}/compile/retry`
    );
    return result.data;
};

export const deleteOutputTemplate = async (id: number) => {
    await axios.delete(`${BASE}/${id}`);
};
